import React from "react";
import Layout from "./../components/Layout/Layout";
import { useSearch } from "../context/Search";
import { useCart } from "../context/cart";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
const Search = () => {
  const navigate = useNavigate();
  const [cart, setCart] = useCart();
  const [values, setValues] = useSearch();
  return (
    <Layout title={"Search results"}>
      <div className="container">
        <div className="text-center">
          <h4 className="mt-3 text-success">Search Resuts</h4>
          <h6>
            {values?.results.length < 1
              ? "No Products Found"
              : `Found ${values?.results.length}`}
          </h6>
          <div className="d-flex flex-wrap mt-4" style={{justifyContent:'center'}}>
            {values?.results.map((p) => (
              <div className="card m-2" style={{ width: "25rem" }}>
                <img
                  src={`https://bablu-server.onrender.com/api/product-photo/${p._id} `}
                  className="card-img-top"
                  alt={p.name}
                />
                <div className="card-body">
                  <h5 className="card-title">{p.name}</h5>
                  <p className="card-text">
                    {p.description.substring(0, 30)}...
                  </p>
                  <p className="card-text"> $ {p.price}</p>
                  <button class="btn btn-primary ms-1"onClick={()=> navigate(`/product/${p.slug}`)}>More Details</button>
                  {/* <button class="btn btn-secondary ms-1 mt-3">ADD TO CART</button> */}
                  <button
                    className="btn btn-secondary ms-1"
                    style={{fontSize:'16px'}}
                    onClick={() => {
                      setCart([...cart, p]);
                      localStorage.setItem(
                        "cart",
                        JSON.stringify([...cart, p])
                      );
                      toast.success("Item Added to cart");
                    }}
                  >
                    ADD TO CART
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Search;